.root {
  display: inline-flex;
  min-width: 0;
  max-width: 100%;
  white-space: nowrap;
}

.start {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.suffix {
  display: inline-block;
  flex-shrink: 0;
  vertical-align: middle;
}
